<template>
    <form lpformnum="3" role="form" @submit.prevent="login">
        <email-input
            @clear="$emit('clearEmail')"
            :disabled="true"
            :value="email"
        ></email-input>
        <div class="form-group">
            <label for="password">Password</label>
            <password-input v-model="password"></password-input>
        </div>
        <submit-button
            :loading="loading"
            text="Login & Proceed"
        ></submit-button>
    </form>
</template>

<script>
import axios from "axios";

import EmailInput from './Inputs/Email.vue';
import PasswordInput from './Inputs/Password.vue';
import SubmitButton from "./SubmitButton.vue";

import loginResponse from "./mixins/loginResponse";

export default {
    name: 'Login',

    components: {
        EmailInput,
        PasswordInput,
        SubmitButton,
    },

    props: {
        email: {
            required: true,
            type: String,
        },
        redirect: {
            default: '',
            required: false,
            type: String,
        },
        urlPrefix: {
            required: true,
            type: String,
        },
    },

    data() {
        return {
            loading: false,
            password: '',
        }
    },

    methods: {
        async login() {
            this.loading = true;

            await axios
                .post(`${this.urlPrefix}/api/internal/users/login.json`, {
                    email: this.email, password: this.password,
                }, {
                    headers: {
                        'Accept': 'application/vnd.api+json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                })
                .then(response => loginResponse(response, this))
                .catch(() => this.$emit('error'));

            this.loading = false;
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Users/LoginOrSignup/Login.vue